import React from 'react';

import { Label } from 'reactstrap';
import DatePicker from 'components/DatePicker';

export default function TaskFormSidebarDatePicker(props) {
    //data & queries
    const {
        label,
        required,
        showEdit,
        value,
        editValue,
        onChangeEditValue,
        placeholder,
        valueContainerStyle,
    } = props;

    //used sidebar
    return (
        <div className="form-selects-entry-column">
            <Label>
                {label}
                {required && (
                    <span className="warning-big m-l-5">
                        *
                    </span>
                )}
            </Label>
            <div className="form-selects-entry-column-rest">
                {!showEdit && (
                    <div
                        className="disabled-info"
                        style={valueContainerStyle}
                    >
                        {value}
                    </div>
                )}
                {showEdit && (
                    <DatePicker
                        className="form-control"
                        selected={editValue}
                        hideTime
                        isClearable
                        onChange={onChangeEditValue}
                        placeholderText={placeholder}
                    />
                )}
            </div>
        </div>
    );
}
